import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { Text, ToggleButton, ToggleButtonGroup } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const [value, setValue] = useState("gallery");

	const onChange = (event: object, value: string) => {
		// set value if it has changed (non-null)
		if (value !== null) {
			setValue(value);
		}
	};

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="enabled" />
			<Text semiBold text="disabled" />
			<ToggleButtonGroup
				aria-label="view mode"
				exclusive
				onChange={onChange}
				value={value}
			>
				<ToggleButton
					aria-label="table"
					tooltipProps={{ res: "ListView" }}
					value="table"
				>
					<ViewHeadlineIcon />
				</ToggleButton>
				<ToggleButton
					aria-label="gallery"
					tooltipProps={{ res: "GalleryView" }}
					value="gallery"
				>
					<ViewModuleIcon />
				</ToggleButton>
			</ToggleButtonGroup>
			<ToggleButtonGroup
				aria-label="view mode"
				exclusive
				value="table"
			>
				<ToggleButton
					aria-label="table"
					disabled
					tooltipProps={{ res: "ListView" }}
					value="table"
				>
					<ViewHeadlineIcon />
				</ToggleButton>
				<ToggleButton
					aria-label="gallery"
					disabled
					tooltipProps={{ res: "GalleryView" }}
					value="gallery"
				>
					<ViewModuleIcon />
				</ToggleButton>
			</ToggleButtonGroup>
		</CssColumnGrid>
	);
};